import roofRepairHero from "@/assets/service-heroes/roof-repair-hero.jpg.asset.json";
import roofReplacementHero from "@/assets/service-heroes/roof-replacement.jpg.asset.json";
import emergencyRoofRepairHero from "@/assets/service-heroes/emergency-roof-repair.jpg.asset.json";
import roofInspectionHero from "@/assets/service-heroes/roof-inspection.jpg";
import residentialRoofingHero from "@/assets/service-heroes/residential-roofing.jpg.asset.json";
import commercialRoofingHero from "@/assets/service-heroes/commercial-roofing.jpg.asset.json";
import roofLeakRepairHero from "@/assets/service-heroes/roof-leak-repair.jpg.asset.json";
import flatRoofRepairHero from "@/assets/service-heroes/flat-roof-repair.jpg";
import roofMaintenanceHero from "@/assets/service-heroes/roof-maintenance.jpg.asset.json";
import roofInsuranceClaimsHero from "@/assets/service-heroes/roof-insurance-claims.jpg.asset.json";
import solarInstallationHero from "@/assets/service-heroes/solar-installation.jpg.asset.json";
import solarBatteryHero from "@/assets/service-heroes/solar-battery-installation.jpg.asset.json";
import commercialSolarHero from "@/assets/service-heroes/commercial-solar.jpg.asset.json";
import solarPanelReplacementHero from "@/assets/service-heroes/solar-panel-replacement.jpg.asset.json";
import solarPanelRepairHero from "@/assets/service-heroes/solar-panel-repair.jpg";
import teslaPowerwallHero from "@/assets/service-heroes/tesla-powerwall-installation.jpg.asset.json";
import solarInverterHero from "@/assets/service-heroes/solar-inverter-installation.jpg.asset.json";
import evChargerHero from "@/assets/service-heroes/ev-charger-installation.jpg.asset.json";
import solarPanelRemovalReinstallHero from "@/assets/service-heroes/solar-panel-removal-reinstallation.jpg";
import solarCarportsHero from "@/assets/service-heroes/solar-carports.jpg";
import solarPanelCleaningHero from "@/assets/services/solar-panel-cleaning.jpg";
import pictureFrameSolarHero from "@/assets/specialty/picture-frame-solar.jpg";
import solarEnergyHero from "@/assets/mckay/solar-energy.webp.asset.json";
import tpoRoofingHero from "@/assets/service-heroes/tpo-roofing.jpg.asset.json";
import modifiedBitumenHero from "@/assets/service-heroes/modified-bitumen-roofing.jpg.asset.json";
import builtUpRoofingHero from "@/assets/service-heroes/built-up-roofing.jpg.asset.json";
import torchDownRoofingHero from "@/assets/service-heroes/torch-down-roofing.jpg.asset.json";
import singlePlyRoofingHero from "@/assets/service-heroes/single-ply-roofing.jpg.asset.json";
import asphaltShingleHero from "@/assets/service-heroes/asphalt-shingle-roofing.jpg";
import tileRoofingHero from "@/assets/service-heroes/tile-roofing.jpg";
import luxuryShingleHero from "@/assets/service-heroes/luxury-shingle-roofing.jpg";
import standingSeamHero from "@/assets/service-heroes/standing-seam-metal-roofing.jpg";
import architecturalSheetMetalHero from "@/assets/service-heroes/architectural-sheet-metal.jpg";

/**
 * Shared map of service slug -> hero/card image URL.
 * Used by both the service hub cards and the individual service page heroes
 * so the card image and the destination page hero always match.
 */
export const serviceHeroImages: Record<string, string> = {
  // Roofing
  "roof-repair": roofRepairHero.url,
  "roof-replacement": roofReplacementHero.url,
  "emergency-roof-repair": emergencyRoofRepairHero.url,
  "roof-inspection": roofInspectionHero,
  "residential-roofing": residentialRoofingHero.url,
  "commercial-roofing": commercialRoofingHero.url,
  "roof-leak-repair": roofLeakRepairHero.url,
  "flat-roof-repair": flatRoofRepairHero,
  "roof-maintenance": roofMaintenanceHero.url,
  "roof-insurance-claims": roofInsuranceClaimsHero.url,
  // Solar
  "solar-installation": solarInstallationHero.url,
  "solar-battery-installation": solarBatteryHero.url,
  "commercial-solar": commercialSolarHero.url,
  "solar-panel-replacement": solarPanelReplacementHero.url,
  "solar-panel-repair": solarPanelRepairHero,
  "tesla-powerwall-installation": teslaPowerwallHero.url,
  "solar-inverter-installation": solarInverterHero.url,
  "ev-charger-installation": evChargerHero.url,
  "solar-panel-removal-reinstallation": solarPanelRemovalReinstallHero,
  // Roof systems
  "tpo-roofing": tpoRoofingHero.url,
  "modified-bitumen-roofing": modifiedBitumenHero.url,
  "built-up-roofing": builtUpRoofingHero.url,
  "torch-down-roofing": torchDownRoofingHero.url,
  "single-ply-roofing": singlePlyRoofingHero.url,
  "asphalt-shingle-roofing": asphaltShingleHero,
  "tile-roofing": tileRoofingHero,
  "luxury-shingle-roofing": luxuryShingleHero,
  "standing-seam-metal-roofing": standingSeamHero,
  "architectural-sheet-metal": architecturalSheetMetalHero,
  // Solar service & structures
  "solar-carports": solarCarportsHero,
  "solar-repair": solarPanelCleaningHero,
  "solar-inverter-repair": pictureFrameSolarHero,
  "solar-monitoring-repair": solarEnergyHero.url,
};

/** Hero/card image for a service slug, falling back to a generic roofing photo. */
export function getServiceHeroImage(slug: string): string {
  return serviceHeroImages[slug] ?? serviceHeroImages["residential-roofing"];
}
